import { createSlice } from "@reduxjs/toolkit";
import { getPermissionList } from "./thunk";

export const initialState = {
  permission: null,
  permissionTypes: null,
}

const permissionSlice = createSlice({
  name: "Permission",
  initialState,
  reducers: {
    setPermissionTypes(state, action) {
      state.permissionTypes = action.payload;
    },
    resetPermissions(state) {
      state.permission = null,
      state.permissionTypes = null
    }
  },
  extraReducers: builder => {
    builder.addCase(getPermissionList.fulfilled, (state, action) => {
      state.permission = action.payload;
    })
  } 
});

export const {  
  setPermissionTypes,
  resetPermissions
} = permissionSlice.actions;

export default permissionSlice.reducer;